class SwatchSwitcher extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onSwatchClick.bind(this));
  }

  async onSwatchClick(event) {
    const link = event.target.closest('a');
    if (!link || link.classList.contains('is-selected')) return;
    event.preventDefault();

    const card = this.closest('product-card');
    if (!card) return;

    card.classList.add('is-loading');

    try {
      const response = await fetch(`${link.href}?view=card`);
      if (!response.ok) throw new Error('Card fetch failed');

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newCard = doc.querySelector('product-card');

      if (newCard) {
        card.replaceWith(newCard);
        window.history.replaceState({}, '', link.href);
      } else {
        window.location.href = link.href;
      }
    } catch (error) {
      console.error('Swatch switch failed:', error);
      window.location.href = link.href;
    } finally {
      card.classList.remove('is-loading');
    }
  }
}

customElements.define('swatch-switcher', SwatchSwitcher);